export const COMPANY_FORM_INITIAL = {
  companyName: "",
  country: "",
  address: "",
  businessNo: "",
  companyType: "",
  industrySector: "",
};
